import { Footer } from '../components/Footer.js';
import { Nav } from '../components/Nav.js';

const TLDR = [
  'Vos données personnelles restent chiffrées sur le boîtier Cadran à votre domicile.',
  'Nous ne vendons, ne louons et ne partageons aucune donnée avec des tiers à des fins commerciales.',
  'Tailscale assure uniquement le tunnel chiffré : il ne voit que les IPs et le nom SNI.',
  "Vous pouvez exporter ou supprimer l'intégralité de vos données à tout moment depuis l'app.",
  'Aucun cookie de traçage. Aucune régie publicitaire.',
];

const SECTIONS = [
  {
    id: 'collecte',
    n: '01',
    title: 'Données collectées',
    body: "Lors de la création d'un foyer : prénom, adresse e-mail, informations de facturation. Sur le boîtier Pi : agenda, messages, photos, journal d'activité — stockés localement en base SQLCipher chiffrée.",
  },
  {
    id: 'usage',
    n: '02',
    title: 'Usage des données',
    body: "Les données du boîtier servent exclusivement au fonctionnement du service (affichage, alertes, synchronisation famille). L'adresse e-mail sert à l'authentification et aux communications de service.",
  },
  {
    id: 'duree',
    n: '03',
    title: 'Durée de conservation',
    body: 'Vous configurez vous-même la durée de rétention des messages et photos (1 à 3 650 jours, ou sans limite). Les données du boîtier sont purgées selon ces réglages. La suppression du foyer déclenche une cascade effective sur toutes les tables.',
  },
  {
    id: 'sous-traitants',
    n: '04',
    title: 'Sous-traitants',
    body: 'Tailscale Inc. (tunnel réseau chiffré) — voir leur politique de confidentialité. Aucun autre sous-traitant pour le stockage ou le traitement des données personnelles en V1.',
  },
  {
    id: 'localisation',
    n: '05',
    title: 'Localisation des données',
    body: "Le boîtier Cadran est physiquement chez vous. Les données métier (agenda, messages, photos) n'en sortent pas. Le relay Cadran (authentification + signalement de présence) tourne sur un serveur en cours de localisation contractuelle en UE.",
  },
  {
    id: 'chiffrement',
    n: '06',
    title: 'Chiffrement',
    body: 'Base SQLCipher, clé HKDF dérivée du matériel Pi + secret de boot. Secrets applicatifs chiffrés AES-256-GCM. Le tunnel Tailscale utilise WireGuard (Curve25519 + ChaCha20-Poly1305).',
  },
  {
    id: 'droits',
    n: '07',
    title: 'Vos droits RGPD',
    body: "Accès, rectification, effacement, portabilité, opposition : disponibles directement depuis l'application (export ZIP, suppression cascade). Pour toute demande hors-app : bonjour@cadran.cloud. Délai de réponse : 30 jours.",
  },
  {
    id: 'cookies',
    n: '08',
    title: 'Cookies & traceurs',
    body: "Ce site n'utilise aucun cookie de traçage, aucune régie publicitaire, aucun outil d'analytics tiers. Un cookie de session technique est utilisé pour l'authentification sur l'app Famille.",
  },
] as const;

export function Confidentialite() {
  return (
    <>
      <Nav />
      <main>
        <div className="page-intro container">
          <div className="eyebrow">Confidentialité</div>
          <h1>
            Vos données, <em>chez vous</em>.
          </h1>
        </div>

        <div className="container" style={{ paddingBottom: '48px' }}>
          <div className="card" style={{ background: 'var(--paper-2)', marginBottom: '56px' }}>
            <div className="eyebrow" style={{ marginBottom: '16px' }}>
              TL;DR — En cinq points
            </div>
            <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'grid', gap: '12px' }}>
              {TLDR.map((point) => (
                <li
                  key={point}
                  style={{
                    display: 'flex',
                    gap: '12px',
                    fontSize: '15px',
                    color: 'var(--ink)',
                    lineHeight: 1.5,
                  }}
                >
                  <span style={{ color: 'var(--moss)', fontWeight: 600, flexShrink: 0 }}>✓</span>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          className="container"
          style={{
            display: 'grid',
            gridTemplateColumns: '240px 1fr',
            gap: '56px',
            paddingBottom: '96px',
            alignItems: 'start',
          }}
        >
          <nav style={{ position: 'sticky', top: '96px' }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {SECTIONS.map((s) => (
                <li key={s.id} style={{ marginBottom: '8px' }}>
                  <a
                    href={`#${s.id}`}
                    className="small"
                    style={{ display: 'block', padding: '6px 0', color: 'var(--ink-soft)' }}
                  >
                    {s.n} — {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <div>
            {SECTIONS.map((s) => (
              <section
                key={s.id}
                id={s.id}
                style={{ marginBottom: '48px', scrollMarginTop: '100px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '16px',
                    marginBottom: '16px',
                    borderBottom: '1px solid var(--hairline-soft)',
                    paddingBottom: '12px',
                  }}
                >
                  <span
                    className="serif"
                    style={{
                      fontStyle: 'italic',
                      fontWeight: 300,
                      fontSize: '28px',
                      color: 'var(--terracotta-deep)',
                    }}
                  >
                    {s.n}
                  </span>
                  <h2
                    style={{
                      margin: 0,
                      fontFamily: 'Fraunces Variable, serif',
                      fontWeight: 500,
                      fontSize: '22px',
                    }}
                  >
                    {s.title}
                  </h2>
                </div>
                <p
                  style={{
                    margin: 0,
                    fontSize: '15.5px',
                    lineHeight: 1.6,
                    color: 'var(--ink-soft)',
                  }}
                >
                  {s.body}
                </p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
